module.exports = __webpack_public_path__ + "static/media/people-say-quotes.84b49bb2.svg";